/* eslint-disable */
import 'script-loader!jquery';
import 'script-loader!what-input';
import 'script-loader!foundation-sites';
import 'babel-polyfill'
import Vue from 'vue'
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.less';

import router from '@/router'
import App from '@/App'
import keyObserver from '@/utils/keyObserver'
import i18n from '@/utils/i18n'
import store from '@/store'
import InputChange from '@/plugin/InputChange'
import FusionInputCheck from '@/plugin/FusionInputCheck'
import VTooltip from '@/controls/tooltip'
import * as app from '@/api/apps/request'
import filters from '@/filters'
import globalProps from '@/globalProps'
import directives from '@/directives'
import ShowNoticeContent from '@/controls/ShowNoticeContent'
import VueCompositionAPI from '@vue/composition-api'

Vue.config.productionTip = false
Vue.use(VueCompositionAPI)
Vue.use(keyObserver)
Vue.use(InputChange)
Vue.use(FusionInputCheck)
Vue.use(VTooltip)
Vue.use(filters)
Vue.use(directives)
Vue.use(Antd)
Vue.component('ShowNoticeContent', ShowNoticeContent)

Vue.prototype.$globalProps = globalProps
// Init adal authentication - then create Vue app.
// eslint-disable-next-line

const vue = new Vue({
  el: '#app',
  i18n,
  router,
  store,
  template: '<App />',
  components: { App },
  async mounted () {
    document.body.removeAttribute('class')
    const { version, buildAt } = await app.getApiVer() || 'N/A'
    const dataset = document.body.dataset
    dataset.ver = `client ${dataset.ver} - server ${version}`
    dataset.buildAt = `client ${dataset.buildAt} - server ${buildAt}`
  }
})

// @TODO @Gino Pre-production use, examine production data
window.$vm = vue
